import React from "react";

import { MainWrapper } from "./components";
import PageOutline from "../../components/page-outline/PageOutline";

const Spotify = () => {

  return (
    <PageOutline header={{ title: "My Spotify list" }}>
      <MainWrapper>

      <iframe title="spotify-iframe" src="https://open.spotify.com/embed/playlist/4Xv7w5RBLUz71sSzIs4C6b" width="100%" height="100%" frameBorder="0" allowtransparency="false" allow="encrypted-media"></iframe>
      </MainWrapper>
    </PageOutline>
  );
};

export default Spotify;
